export default __webpack_public_path__ + "static/vinai-bitmoji-cd63f1e3a43b52b9f49793d501a4f49a.png";